<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Training Completion Confirmation
							</div>
							<!-- Page Header -->
				
							<div class="page_main">
								<el-form
									ref="trainForm"
									:model="formData"
									:rules="formDataRules"
									label-position="top"
									class="custom-form"
								>
				
									<el-form-item label="Training Item ID" class="full-width-item">
										<div class="gray-input">
											{{ infoData.item_name || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Description" class="full-width-item">
										<div class="gray-input">
											{{ infoData.description || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Training Purpose" class="full-width-item">
										<div class="gray-input" v-if="infoData.is_certification == 1">
											Initial Training
										</div>
										<div class="gray-input" v-if="infoData.is_certification == 2">
											Retraining
										</div>
									</el-form-item>
				
									<el-form-item label="Training Type">
										<div class="gray-input">
											{{ infoData.leixing_name || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Has this requirement been met?">
										<div class="gray-input" v-if="infoData.is_meet == 1">
											Yes
										</div>
										<div class="gray-input" v-if="infoData.is_meet == 2">
											No
										</div>
										<div class="gray-input" v-if="infoData.is_meet == 3">
											N/A
										</div>
									</el-form-item>
				
									<el-form-item label="Training Due Date">
										<div class="gray-input">
											{{ infoData.end_time || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Certification Required?">
										<div class="gray-input" v-if="infoData.is_certification == 1">
											Yes
										</div>
										<div class="gray-input" v-if="infoData.is_certification == 2">
											No
										</div>
									</el-form-item>
				
									<div class="btn_el">
										<div class="tips">
											Please record the date you completed the training. You may also upload a file as evidence of training completion (e.g., test results or attendance records).
										</div>
									</div>
				
									<el-form-item
										label="Training Completion Date"
										prop="training_completed_date"
									>
										<el-date-picker
											v-model="formData.training_completed_date"
											type="date"
											placeholder="Select Date"
											value-format="yyyy-MM-dd"
											format="yyyy-MM-dd"
											class="full-width"
										/>
									</el-form-item>
				
									<!-- Upload -->
									<div class="upload-doc-wrapper">
										<div class="upload-title">
											Training Evidence File
											<span class="upload-limit">
												(Max. 10 MB)
											</span>
										</div>
				
										<div class="upload-box" style="position: relative;">
											<el-upload
												ref="uploadBox"
												class="doc-upload"
												action="/api/trainUploads"
												name="files"
												:data="uploadData"
												:headers="{ token: userToken }"
												:show-file-list="false"
												:before-upload="beforeAvatarUpload"
												:on-success="handleAvatarSuccess"
												:limit="1"
												:with-credentials="true"
											>
												<el-button size="medium" class="select-btn">
													Select File
												</el-button>
											</el-upload>
				
											<div class="file-name" :class="{ placeholder: !fileName }">
												{{ fileName || "No file selected" }}
				
												<span
													v-if="fileName"
													style="position:absolute;right:20px;top:12px;cursor:pointer;color:#f00;"
													@click="delFile"
												>
													Delete
												</span>
											</div>
										</div>
									</div>
				
									<el-form-item label="Comments" prop="training_comments">
										<el-input
											v-model="formData.training_comments"
											type="textarea"
											:rows="5"
											resize="none"
										/>
									</el-form-item>
				
									<el-form-item label="Signature" prop="signature">
										<el-input
											v-model="formData.signature"
											placeholder="Please enter"
											clearable
											show-password
										/>
									</el-form-item>
				
									<div class="action-btns">
										<el-button type="primary" @click="handleSubmit">
											Confirm
										</el-button>
				
										<el-button type="primary" @click="handleCancel">
											Cancel
										</el-button>
									</div>
				
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	ApplyDetail,
	trainUesrsComplete
}
from "@/api/trainManage/myTrain/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from 'moment';
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			fileName: "",
			selectedFile: null,
			uploadData: {
				train_leixing: 1
			},
			infoData: {
				item_name: "",
				description: "",
				purpose: "",
				leixing_name: "",
				is_meet: "",
				end_time: "",
				is_certification: ""
			},
			formData: {
				training_completed_date: "",
				training_comments: "",
				signature: ""
			},
			formDataRules: {
				training_completed_date: [{ required: true, message: "Please select", trigger: "change" }],
				training_comments: [{ required: true, message: "Please enter", trigger: "blur" }],
				signature: [{ required: true, message: "Please enter", trigger: "blur" }]
			},
			userToken: localStorage.getItem("userToken"),
			oid: null
		};
	},
	created() {
		let that = this;
		that.oid = that.$route.query.oid;
	},
	mounted() {
		let that = this;
		//请求详情
		ApplyDetail({ id: that.oid }).then(res => {
			if(res.code == 200) {
				that.infoData = {
					id: res.data.id,
					item_name: res.data.item_name,
					description: res.data.description,
					purpose: res.data.purpose,
					leixing_name: res.data.leixing_name,
					is_meet: res.data.is_meet,
					end_time: res.data.end_time,
					is_certification: res.data.is_certification
				};
				console.log(res.data);
			}
			that.isLoading = false;
		});
	},
	methods: {
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.selectedFile = res.data.id;
			that.fileName = res.data.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10MB");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		//删除文件
		delFile() {
			let that = this;
			that.selectedFile = '';
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		//用户自行完成培训
		handleSubmit() {
			let that = this;
			that.$refs.trainForm.validate((valid1) => {
				if (!valid1) return;
				let query = {
					id: that.infoData.id,
					training_completed_date: moment(that.formData.training_completed_date).valueOf() / 1000,
					training_comments: that.formData.training_comments,
					training_files: that.selectedFile,
					signature: md5(that.formData.signature+'AiisoQms2026')
				};
				// console.log(query);
				that.$toast.loading({ duration: 0, forbidClick: true });
				trainUesrsComplete(query).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.back();
						}, 800);
					}
				});
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.custom-form {
  width: 100%;
}

.full-width {
  width: 100%;
}

::v-deep .full-width .el-input__inner {
  width: 100%;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-name.placeholder {
  color: #999;
}

.action-btns {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>

